import {
  useOptionalPropsBridge,
  usePropsBridge,
} from '@spotify/confidence-core-react';

import type { PageRootBridgeProps } from '../types';

export const usePageBridgeProps = (): PageRootBridgeProps =>
  usePropsBridge<PageRootBridgeProps>();

export const useOptionalPageBridgeProps = (): PageRootBridgeProps | undefined =>
  useOptionalPropsBridge<PageRootBridgeProps>();
